<div [formGroup]="formGroup" class="mb-1">
  <div class="d-flex justify-content-arround flex-wrap ">
    <div class="w-25">
      <label class="form-label">{{label}}<span *ngIf="isRequired"> * </span></label>
    </div>
    <div class="w-75">
      <div *ngIf="errorMessage" class="text-danger text-end">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div class="uploaderMainContainer">
    
    <ngx-dropzone class="fileUploaderContainer"
      (change)="onSelect($event)" (removed)="onRemove($event)"
      [accept]="acceptFileType"
    >
      <div class="d-flex justify-content-center w-100">
        <div class="dz-message needsclick text-center">
          <i class="ti ti-cloud-upload h1 text-muted"></i>
          <h3 class="uploderHeader">{{uploaderHeading}}</h3>
          <span class="text-muted fs-13">{{hintText}}</span>
        </div>
      </div>
    </ngx-dropzone>
    <div class="profile-icon" *ngIf="showProfileImg && preview==''"></div>
    <div *ngIf="files || preview">
      <img [src]="preview" width="126" height="126" alt="image" class="image" />
        <i class="ti ti-circle-x closeIcon" (click)="onRemove(files)"></i>
    </div>
    
  </div>
 
<!-- <div *ngFor="let file of files">
  <p>{{ file.name }}</p>
</div> -->
</div>